const DescriptionTitle = ({ value, ...props }) => {
  return <p {...props}> {value} </p>;
};
export default DescriptionTitle;
